import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { translationEnUs } from '../assets/locale/en-US/en-US';
import { appliance, appliances, appliancesArticle } from '../constants/translations';
import { deepMerge } from '../utils/merge/deepMerge';
import type { Translation, TranslationConfiguration } from './types/types';
export type { TranslationConfiguration } from './types/types';

/**
 * Init i18next with override capabilities for tenant based translations and basic interpolation (e.g appliance or product)
 * @param options
 * @returns
 */
export const initI18Next = (options?: TranslationConfiguration) => {
  const i18nextOptions = options?.initOptions;

  const mergedTranslations: Translation = deepMerge(translationEnUs, options?.translationOverride);
  const baseResources = { en: mergedTranslations };
  const resources = deepMerge(baseResources, i18nextOptions?.resources);

  return i18n.use(initReactI18next).init({
    ...i18nextOptions,
    resources,
    lng: i18nextOptions?.lng ?? 'en-US',
    fallbackLng: i18nextOptions?.fallbackLng ?? 'en',
    interpolation: {
      ...i18nextOptions?.interpolation,
      escapeValue: i18nextOptions?.interpolation?.escapeValue ?? false,
      defaultVariables: {
        appliance: options?.interpolation?.applianceTerminology?.singular ?? appliance,
        appliances: options?.interpolation?.applianceTerminology?.plural ?? appliances,
        applianceArticle:
          options?.interpolation?.applianceTerminology?.singularArticle ?? appliancesArticle,
        ...i18nextOptions?.interpolation?.defaultVariables,
      },
    },
  });
};
